import axios from 'axios'
const service = axios.create({
    baseURL: `${process.env.VUE_APP_HOST_DOMAIN}${process.env.VUE_APP_BASE_API}`,
    timeout: 2 * 60 * 1000
})


service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        if ([403, 401].includes(error.response.status)) {
            return Promise.reject(error)
        }
        return Promise.reject(error)
    }
)

export default service
